import React from 'react';
import I18n from 'i18n-js';
import { RCTextWithIcon } from '@reverbdotcom/cadence/components';
import { ClockCounterClockwiseIcon } from '@phosphor-icons/react';

import { Listing } from '@reverbdotcom/commons/src/gql/graphql';

import { CTA_TYPE, INSIGHT, trackClicked, useTrackingContext, useTrackImpression } from './sellerRecommendationTracking';
import RenewListingButton from '../listings/RenewListingButton';

interface Props {
  listing: Listing;
}

export default function RenewListingPresentment({ listing }: Props) {
  const trackingContext = useTrackingContext();
  useTrackImpression(INSIGHT.RENEW_ELIGIBLE, listing.id);

  const relistDescription = listing.priceRecommendation?.priceMiddle?.display ?
    I18n.t(
      'discovery.listingsManagement.sellerListingCard.insights.renewEligible.descriptionWithPriceRec',
      { displayPrice: listing.priceRecommendation?.priceMiddle?.display },
    ) : I18n.t('discovery.listingsManagement.sellerListingCard.insights.renewEligible.description');

  return (
    <>
      <div className="seller-listing-insight-presentment">
        <span className="seller-listing-insight-presentment__renew-eligible">
          <RCTextWithIcon icon={<ClockCounterClockwiseIcon weight="duotone" />} placement="left" size="large">
            <span className="text-utility-350">
              {relistDescription}
            </span>
          </RCTextWithIcon>
        </span>
        <RenewListingButton
          listing={listing}
          onClick={() => trackClicked(INSIGHT.RENEW_ELIGIBLE, listing.id, CTA_TYPE.RENEW, trackingContext)}
        />
      </div>
    </>
  );
}
